import { MembershipTypeItemType, PricingListItemType, ServerResponse } from '../types/staticValues';

export const pricingListDummy: ServerResponse<PricingListItemType[]> = {
    data: [
        {
            id: 1,
            name: 'Basic',
            price: 10,
        },
        {
            id: 2,
            name: 'Pro',
            price: 20,
        },
        {
            id: 3,
            name: 'Premium',
            price: 30,
        },
    ],
};
export const membershipTypesDummy: ServerResponse<MembershipTypeItemType[]> = {
    data: [
        {
            id: 1,
            name: 'Standard',
        },
        {
            id: 2,
            name: 'Premium',
        },
    ],
};
